import { useNavigation } from "@remix-run/react";
import { useEffect, useState } from "react";

import { AcademiaLoader } from "~/components/AcademiaLoader";

export function GlobalNavigationLoader() {
  const navigation = useNavigation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (navigation.state === "idle") {
      setVisible(false);
      return;
    }

    const timer = window.setTimeout(() => setVisible(true), 180);
    return () => window.clearTimeout(timer);
  }, [navigation.state]);

  if (!visible) return null;

  return (
    <div
      data-testid="global-navigation-loader"
      className="fixed inset-0 z-[9990] flex items-center justify-center bg-[#F7F3EA]/95 backdrop-blur-[2px] dark:bg-[#191613]/95"
    >
      <AcademiaLoader label="Cargando la siguiente sección" />
    </div>
  );
}
